<template>
  <transition name="fade">
    <div v-if="open_modal" class="chat-modal">
        <chat-error></chat-error>
        <div class="chat-modal-wrapper">
          <chat-header></chat-header>
          <transition name="trans">
            <div class="c-block" key="a" v-if="!open_message">
              <div v-if="user.uuid">
                <div class="chat-modal-body" ref="chatListContainer">
                  <transition name="bodyloader">
                    <div v-if="loading" class="chat-modal-body-loader">
                      <svg viewBox="0 0 399 399">
                        <path d="M340.566,58.431A199.5,199.5,0,0,0,58.432,340.57,199.5,199.5,0,1,0,340.566,58.431ZM327.742,71.255A180.177,180.177,0,0,1,380.862,199.5H339.754c0-77.338-62.918-140.256-140.255-140.256-4.589,0-9.125.229-13.6,0.661V18.635q6.756-.5,13.6-0.5A180.177,180.177,0,0,1,327.742,71.255ZM199.5,321.619A122.119,122.119,0,1,1,321.617,199.5,122.256,122.256,0,0,1,199.5,321.619Z"/>
                      </svg>
                    </div>
                  </transition>
                  <div class="chat-modal-body-inner">
                    <chat-list></chat-list>
                  </div>
                </div>
                <div class="chat-modal-footer">
                  <new-chat></new-chat>
                </div>
              </div>
              <chat-login v-else></chat-login>
            </div>
            <div class="c-block" key="b" v-else>
              <message-modal></message-modal>
            </div>
          </transition>
        </div>
    </div>
  </transition>
</template>

<script>
import ChatList from './ChatList'
import NewChat from './NewChat'
import ChatHeader from './ChatHeader'
import MessageModal from './MessageModal'
import ChatLogin from './ChatLogin'
import ChatError from './ChatError'

import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    ChatList,
    NewChat,
    MessageModal,
    ChatHeader,
    ChatLogin,
    ChatError,
  },
  computed: {
    ...mapState(['open_modal', 'open_message', 'user']),
    ...mapState('chatList', ['loading', 'last_page', 'is_end', 'page_loading']),
  },
  methods: {
    ...mapMutations(['closeMessage']),
    ...mapMutations('chatList', ['updateChatPageLoading']),
    getMoreData() {
        if ( !!this.is_end ) return
        this.updateChatPageLoading(true)
        this.$nextTick(() => this.$refs.chatListContainer.scrollTop = this.$refs.chatListContainer.scrollHeight)
        this.$remote.$emit('getconversations', Object.assign({}, this.user, { last_id: this.last_page }, { is_pagination: 1 } ))
    },
    fackEvent() {
      if (this.$refs.chatListContainer.scrollTop == (this.$refs.chatListContainer.scrollHeight - this.$refs.chatListContainer.clientHeight) && !this.page_loading ) {
          console.log('fetch')
          this.getMoreData()
      }
    }
  },
  updated() {
    this.$refs.chatListContainer && this.$refs.chatListContainer.addEventListener('scroll', this.fackEvent, false)
  }
}
</script>


<style lang="scss" scoped>
.chat-modal {z-index: 2147483000!important; position: fixed!important; bottom: calc(20px + 75px); right: 20px; height: calc(100% - 20px - 20px); background: #fff;
  width: 370px!important; min-height: 250px!important; max-height: 590px!important;
  box-shadow: 0 5px 40px rgba(0,0,0,.16)!important; border-radius: 8px!important;
  overflow: hidden; opacity: 1; transform: translateY(0); transform-origin: center bottom;
  &-wrapper {width: 100%; height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0;}
  &-body { position: absolute; top: 75px; bottom: 0; left: 0; right: 0; overflow-y: auto;
    &-inner { padding-bottom: 105px; }
    &-loader {position: absolute; top: 0; left: 0; bottom: 0; right: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;
      background: rgb(255, 255, 255); z-index: 2147483001;
      svg {fill: #ccc; width: 28px; height: 28px; margin-bottom: 50px;
        animation: loaderCyc 1s infinite linear;
      }
    }
  }
  &-footer { z-index: 2147483001; text-align: center; position: absolute; bottom: 0; left: 0;
    right: 0; border-radius: 0 0 6px 6px; height: 90px; pointer-events: none; background: linear-gradient(0deg,#fff,hsla(0,0%,100%,0));
  }
  .c-block {width: 100%; height: 100%; position: absolute; left: 0; top: 0; bottom: 0; right: 0; overflow: hidden;}
}
.fade-enter-active, .fade-leave-active {
  transition: all .25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0; transform: translateY(15px);
}

.trans-enter-active, .trans-leave-active {
  transition: all .4s;
}
.trans-enter, .trans-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0; 
}

.bodyloader-enter-active, .bodyloader-leave-active {
  transition: all .35s;
}
.bodyloader-enter, .bodyloader-leave-to {
  opacity: 0;
}

@keyframes loaderCyc {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


</style>


// WEBPACK FOOTER //
// src/components/ChatModal.vue